import { formatDateTime } from '@customerio/pluma-components/react/utils/formatted-date-time';

export const AccessSource = {
  TS: 'Support team',
  CS: 'Success team',
} as const;

export type AccessSource = (typeof AccessSource)[keyof typeof AccessSource];

export function formatShortDate(timestamp: number | undefined): string {
  if (timestamp == null || timestamp <= 0) return '';
  return formatDateTime(timestamp, 'medium');
}
